import {
  text,
  timestamp,
} from 'drizzle-orm/pg-core'
// VA-223: @w/id, not the @w/be-utils barrel - see tools/drizzle-js-ts-resolve.cjs.
import { ulid } from '@w/id'

export const id = text('id')
  .primaryKey()
  .notNull()
  .$defaultFn(() => ulid())
export const createdAt = timestamp('created_at', { mode: 'date' }).defaultNow().notNull()
export const updatedAt = timestamp('updated_at', { mode: 'date' })
  .defaultNow()
  .notNull()
  .$onUpdateFn(() => new Date())
